import { render, staticRenderFns } from "./DonationTicker.vue?vue&type=template&id=3354e66a&scoped=true&"
import script from "./DonationTicker.vue?vue&type=script&lang=js&"
export * from "./DonationTicker.vue?vue&type=script&lang=js&"
import style0 from "./DonationTicker.vue?vue&type=style&index=0&id=3354e66a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3354e66a",
  null
  
)

export default component.exports